import _RentalPaymentApprovalService from "../services/rental-payment-approval-service";
import { IRentalPaymentApprovalService } from "../types/services/rental-payment-approval-service";

const instance = new _RentalPaymentApprovalService();

const RentalPaymentApprovalService: IRentalPaymentApprovalService = instance;

export default RentalPaymentApprovalService;
